import { motion } from "framer-motion";

export const Nav = () => {
  return (
    <motion.nav
      data-testid="site-nav"
      initial={{ y: -40, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, delay: 1.4, ease: [0.16, 1, 0.3, 1] }}
      className="fixed top-0 left-0 right-0 z-50"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-6 md:px-10">
        <a
          href="#top"
          data-testid="nav-logo"
          className="font-display text-xl font-extrabold tracking-tighter text-white"
        >
          THE<span className="text-[#ccff00]">/</span>DROP
        </a>
        <div className="hidden items-center gap-8 font-mono-accent text-xs uppercase tracking-[0.2em] text-zinc-400 md:flex">
          <a href="#drops" data-testid="nav-drops" className="transition-colors duration-300 hover:text-white">
            Drops
          </a>
          <a href="#manifesto" data-testid="nav-manifesto" className="transition-colors duration-300 hover:text-white">
            Manifesto
          </a>
          <a href="#faq" data-testid="nav-faq" className="transition-colors duration-300 hover:text-white">
            FAQ
          </a>
          <a href="#contact" data-testid="nav-contact" className="transition-colors duration-300 hover:text-white">
            Contact
          </a>
        </div>
        <a
          href="#drops"
          data-testid="nav-cta"
          className="rounded-full bg-[#ccff00] px-5 py-2 font-mono-accent text-xs font-bold uppercase tracking-[0.15em] text-black transition-transform duration-300 hover:scale-95"
        >
          Get 10% Off
        </a>
      </div>
    </motion.nav>
  );
};
